import { Cell, Grid, Heading, HFlow, Icon, Text } from 'bold-ui'
import { InfoIcon } from 'components/InfoIcon'
import { Color } from 'csstype'
import { css } from 'emotion'
import React from 'react'
import { formatDate } from 'util/date/formatDate'
import { isNumberInRange } from 'util/number/number-in-range'
import { IDADE_FORA_DE_RASTREIO_TEXT } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-saudeMulher'

import {
  RANGE_IDADE_RASTREIO_SAUDE_SEXUAL_REPRODUTIVA,
  ULTIMA_CONSULTA_SAUDE_SEXUAL_REPRODUTIVA_TOOLTIP_TEXT,
} from './constants-saudeMulher'

interface UltimaConsultaSaudeSexualReprodutivaPanelProps {
  data: LocalDate
  idadeCidadao: number
  iconColor: Color
}

export function UltimaConsultaSaudeSexualReprodutivaPanel(
  props: Readonly<UltimaConsultaSaudeSexualReprodutivaPanelProps>
) {
  const { data, idadeCidadao, iconColor } = props

  const isInRange = isNumberInRange(idadeCidadao, RANGE_IDADE_RASTREIO_SAUDE_SEXUAL_REPRODUTIVA)

  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.25} alignItems='center'>
          <Icon icon='nurse' size={1} color={iconColor} />
          <Heading level={4}>Última consulta de saúde sexual e reprodutiva</Heading>
          <InfoIcon
            icon='infoCircleFilled'
            text={ULTIMA_CONSULTA_SAUDE_SEXUAL_REPRODUTIVA_TOOLTIP_TEXT}
            tooltipStyle={styles.tooltip}
          />
        </HFlow>
      </Cell>
      <Cell size={12}>
        {isInRange ? <Text>{formatDate(data)}</Text> : <Text fontStyle='italic'>{IDADE_FORA_DE_RASTREIO_TEXT}</Text>}
      </Cell>
    </Grid>
  )
}

const styles = {
  tooltip: css`
    max-width: 31rem;
    white-space: pre-line;
  `,
}
